import Keycloak from 'keycloak-js';

const onLoad: Keycloak.KeycloakOnLoad = 'login-required';

export const INIT_CONFIG: Keycloak.KeycloakInitOptions = { checkLoginIframe: false, onLoad };

declare const REACT_APP_ENV: { [index: string]: string | null | undefined };

const url = REACT_APP_ENV.REACT_APP_KEYCLOAK_URL ?? import.meta.env.REACT_APP_KEYCLOAK_URL;
const realm = REACT_APP_ENV.REACT_APP_KEYCLOAK_REALM ?? import.meta.env.REACT_APP_KEYCLOAK_REALM;
const clientId = REACT_APP_ENV.REACT_APP_KEYCLOAK_CLIENT_ID ?? import.meta.env.REACT_APP_KEYCLOAK_CLIENT_ID;
const versionNumber = REACT_APP_ENV.REACT_APP_VERSION ?? import.meta.env.REACT_APP_VERSION;

if (!url) {
  throw new Error(
    'не задана переменная окружения REACT_APP_KEYCLOAK_URL, для rss-dev - http://rss-client.dev.k8s.ksnm.adp.local/auth',
  );
}

if (!realm) {
  throw new Error('не задана переменная окружения REACT_APP_KEYCLOAK_REALM, для rss-dev - ksnm');
}

if (!clientId) {
  throw new Error('не задана переменная окружения REACT_APP_KEYCLOAK_CLIENT_ID, для rss-dev - ksnm-client');
}

if (!versionNumber) {
  throw new Error('не задана переменная окружения REACT_APP_VERSION');
}

const keycloakConfig = {
  url,
  realm,
  clientId,
};

export const keycloak = Keycloak(keycloakConfig);
